class CountDown {
    constructor() {
        // 开启一个定时器
        this.list = [];
        this.switch = false;
        this.initStopWatch();
    }
    initStopWatch() {
        if (this.switch) return;
        this.switch = true;
        this.stopWatch = setInterval(() => {
            if (this.list.length > 0) {
                this.list.forEach(item => {
                    item();
                });
            } else {
                clearInterval(this.stopWatch);
                this.switch = false;
            }
        }, 1000);
    }
    add(fn) {
        this.list.push(fn);
        if (!this.switch) {
            this.initStopWatch();
        }
    }
    off(fn) {
        this.list.forEach((item, index) => {
            if (item === fn) {
                this.list.splice(index, 1);
            }
        });
    }
}
export default CountDown;
